import { extractTitleTextColor, extractSummary } from '../common/primitives';
import { extractLozenge } from '../common/lozenge';
import { extractIcon } from '../common/icon';
import { extractCommentCount, extractProgrammingLanguage, extractSubscriberCount, extractAttachmentCount } from '../common/detail';
import { extractLink, extractTitle, extractProvider, extractMembers, extractPersonAssignedTo, extractPersonCreatedBy, extractPersonUpdatedBy, extractImage } from '@atlaskit/link-extractors';
import { extractByline } from '../common/byline/extractByline';
import { extractTitlePrefix } from '../common/title-prefix/extractTitlePrefix';
import { extractClientActions } from '../common/actions/extractActions';
import { extractPreviewAction } from '../common/actions/extractPreviewAction';
import { extractIsTrusted } from '../common/meta/extractIsTrusted';
const extractBlockIcon = jsonLd => {
  const icon = extractIcon(jsonLd);
  if (typeof icon === 'string') {
    return {
      url: icon
    };
  } else {
    return {
      icon
    };
  }
};
const extractBlockDetails = jsonLd => [extractCommentCount(jsonLd), extractProgrammingLanguage(jsonLd), extractSubscriberCount(jsonLd), extractAttachmentCount(jsonLd)].filter(detail => !!detail);
export const extractBlockActions = (props, jsonLd, opts, platform, meta) => {
  if (opts) {
    const {
      handleInvoke,
      actionOptions
    } = opts;
    const actions = extractClientActions(jsonLd, handleInvoke, actionOptions);
    const previewAction = extractPreviewAction({
      ...opts,
      viewProps: props,
      jsonLd,
      platform,
      meta
    });

    // The previewAction should always be the last action
    if (previewAction) {
      actions.push(previewAction);
    }
    return actions;
  }
  return [];
};
export const extractBlockUsers = jsonLd => {
  if (jsonLd['@type'] === 'atlassian:Project') {
    return extractMembers(jsonLd);
  } else if (jsonLd['@type'] === 'atlassian:Task') {
    const assignedMembers = extractPersonAssignedTo(jsonLd);
    if (assignedMembers) {
      return [assignedMembers];
    }
  } else if (jsonLd['@type'] === 'atlassian:SourceCodePullRequest') {
    return extractPersonCreatedBy(jsonLd);
  } else {
    const updatedBy = extractPersonUpdatedBy(jsonLd);
    let updatedByMembers;
    if (updatedBy) {
      updatedByMembers = [updatedBy];
    }
    const createdByMembers = extractPersonCreatedBy(jsonLd);
    return updatedByMembers || createdByMembers;
  }
};
export const extractBlockProps = (jsonLd, meta, opts, renderers, platform) => {
  const props = {
    link: extractLink(jsonLd),
    title: extractTitle(jsonLd),
    titleTextColor: extractTitleTextColor(jsonLd),
    lozenge: extractLozenge(jsonLd),
    icon: extractBlockIcon(jsonLd),
    context: extractProvider(jsonLd),
    details: extractBlockDetails(jsonLd),
    byline: extractSummary(jsonLd) || extractByline(jsonLd),
    thumbnail: extractImage(jsonLd),
    users: extractBlockUsers(jsonLd),
    titlePrefix: extractTitlePrefix(jsonLd, renderers, 'block'),
    isTrusted: extractIsTrusted(meta)
  };
  return {
    ...props,
    actions: extractBlockActions(props, jsonLd, opts, platform, meta)
  };
};